import { Interpolation } from "@emotion/core";
import { darken } from "polished";
import { grid } from "../../../../../../../design-tokens/grid";
import {
  DarkTheme,
  Device,
} from "../../../../../../../design-tokens/media-queries";
import { Colors } from "../../../../../../../design-tokens/colors";
import { Border } from "../../../../../../../design-tokens/borders";
import { Fonts } from "../../../../../../../design-tokens/fonts";

const container: Interpolation = {
  backgroundColor: Colors.LightGrey,
  paddingBottom: grid(2),
  marginBottom: grid(3),
  overflow: "hidden",
  overflowX: "auto",

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeBlack,
  },

  [Device.DesktopTablet]: {
    borderRadius: Border.Radius,
    marginBottom: grid(4),
  },

  [Device.Mobile]: {
    marginLeft: grid(-2),
    marginRight: grid(-2),
  },
};

const row: Interpolation = {
  display: "flex",
  minWidth: "100%",

  "> div": {
    display: "flex",
    alignItems: "center",
    padding: grid(2),
  },

  "> div:nth-of-type(1)": {
    flexGrow: 0,
    flexShrink: 0,
    width: "20%",
    minWidth: grid(9),

    [Device.DesktopTablet]: {
      width: "35%",
    },
  },

  "> div:nth-of-type(2)": {
    width: "40%",
    justifyContent: "flex-end",
    textAlign: "right",
    paddingLeft: 0,
    minWidth: grid(13.5),

    [Device.DesktopTablet]: {
      width: "25%",
    },
  },

  "> div:nth-of-type(3)": {
    width: "20%",
    justifyContent: "flex-end",
    textAlign: "right",
    paddingLeft: 0,
    minWidth: grid(7.5),

    [Device.DesktopTablet]: {
      width: "20%",
    },
  },

  "> div:nth-of-type(4), > div:nth-of-type(5)": {
    width: "20%",
    justifyContent: "flex-end",
    textAlign: "right",
    paddingLeft: 0,
    minWidth: grid(7.5),

    [Device.DesktopTablet]: {
      width: "20%",
    },
  },
};

const tableHeader: Interpolation = {
  fontWeight: Fonts.Weight.SemiBold,
  lineHeight: "20px",

  [Device.Mobile]: {
    fontSize: "12px",
    lineHeight: "15px",
  },

  "> div": {
    backgroundColor: darken(0.05, Colors.LightGrey),

    [DarkTheme]: {
      backgroundColor: Colors.DarkModeDeepBlack,
    },
  },
};

const countryRow: Interpolation = {
  ":hover": {
    backgroundColor: darken(0.02, Colors.LightGrey),

    [DarkTheme]: {
      backgroundColor: darken(0.02, Colors.DarkModeBlack),
    },
  },
};

const contentRow: Interpolation = {
  "> div": {
    fontSize: "16px",
    lineHeight: "20px",
    paddingTop: grid(1.5),
    paddingBottom: grid(1),

    [Device.DesktopTablet]: {
      fontSize: "22px",
      lineHeight: "30px",
    },
  },

  "> div:nth-of-type(1)": {
    [Device.Mobile]: {
      width: "35%",
      minWidth: grid(13.5),
    },
  },

  "> div:nth-of-type(2)": {
    fontWeight: "bold",

    [Device.Mobile]: {
      width: "25%",
      minWidth: grid(9),
    },
  },

  "> div:nth-of-type(4), > div:nth-of-type(5)": {
    fontWeight: "bold",
  },
};

const barCell: Interpolation = {
  paddingLeft: grid(2),
  paddingRight: grid(2),
  paddingBottom: grid(1.5),
  paddingTop: 0,
};

const bar: Interpolation = {
  height: grid(0.5),
  borderRadius: grid(1),

  [Device.DesktopTablet]: {
    height: 7,
  },
};

const sortTab: Interpolation = {
  cursor: "pointer",
};

const upArrow = (color: string): Interpolation => ({
  display: "block",
  width: "0",
  height: "0",
  borderStyle: "solid",
  borderWidth: "0 5px 10px 5px",
  borderColor: `transparent transparent ${color} transparent`,
  marginLeft: grid(0.5),
});

const downArrow = (color: string): Interpolation => ({
  display: "block",
  width: "0",
  height: "0",
  borderStyle: "solid",
  borderWidth: "10px 5px 0 5px",
  borderColor: `${color} transparent transparent transparent`,
  marginLeft: grid(0.5),
});

const countryLink: Interpolation = {
  color: Colors.Black,

  [DarkTheme]: {
    color: Colors.DarkModeWhite,
  },
};

const indicator: Interpolation = {
  display: "inline-block",
  width: 7,
  height: 7,
  marginLeft: grid(0.5),
  borderRadius: "50%",
  backgroundColor: Colors.Blue,

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeTextBlue,
  },

  [Device.DesktopTablet]: {
    width: 10,
    height: 10,
    marginLeft: grid(1),
  },
};

const hideDesktop: Interpolation = {
  [Device.DesktopTablet]: {
    display: "none !important",
  },
};

const hideMobile: Interpolation = {
  [Device.Mobile]: {
    display: "none !important",
  },
};

const styles = {
  container,
  row,
  tableHeader,
  countryRow,
  contentRow,
  barCell,
  bar,
  sortTab,
  upArrow,
  downArrow,
  indicator,
  countryLink,
  hideDesktop,
  hideMobile,
};

export default styles;
